import "./index.css"

function LoadingState() {
  return <>
  <div className="empty-message-holder">
  <img src="./images/loading.gif" alt="loading state" className="loading-state"></img>
  </div>
  </>
  }

export default LoadingState;